<template>
  <main class="relative max-h-screen font-roboto overflow-hidden">
    <img src="../../assets/images/login_bg.jpg" alt="" class="w-full h-screen object-cover mobile:scale-[1.5] tablet:scale-[1.4] laptop:scale-100">
    <div class="absolute mobile:w-full largeDesktop:w-[700px] laptop:w-[550px] top-0 right-0">
      <div
        class="mobile:px-8 tablet:px-32 laptop:px-48 desktop:px-16 largeDesktop:px-28 h-screen flex flex-col items-center justify-center bg-[#2359a8f0] laptop:bg-[#2459A8]">
        <img src="../../assets/images/MyHappy-Logo.png"
          class="w-[210px] tablet:w-[265px] object-cover mb-[20px] largeDesktop:mb-[60px]" alt="fyxify Logo">
          <h4
            class="flex justify-center items-center gap-[10px] text-center font-roboto text-2xl tablet:text-3xl laptop:text-[28px] largeDesktop:text-[35px] font-medium mobile:my-3 tablet:my-5 largeDesktop:my-10 text-white">
            Welcome to
            <img src="../../assets/images/MyHappy-heading-logo.png" 
            class="w-[170px] tablet:w-[200px] largeDesktop:w-[235px] object-contain mt-1.5" alt="fyxify Logo">
          </h4>
        
        <div class="grid w-full tablet:max-w-[400px] mobile:gap-2 tablet:gap-4 largeDesktop:gap-5">
          <div class="form-group">
            <label for="email" class="text-base font-roboto font-normal mb-1 text-white">Email:</label>
            <inputComponent ref="emailRef" v-model="email" name="email" required :regex="$constants.EMAIL_REGEX" errorClass="!text-customYellow-100"
              error-message="Please enter a valid email address" placeholder="Enter Email" customClass="!text-[16px] mobile:!p-[9px] largeDesktop:!p-[11px] !rounded-[5px]" />
            <!-- <input v-model="email" type="email" class="form-control focus:border-gray-400" placeholder="Enter email"> -->
          </div>
          <div class="form-group">
            <label for="password" class="text-base font-roboto font-normal mb-1 text-white">Password:</label>
            <div class="relative">
              <inputComponent v-model="password" ref="passwordRef" name="password" type="password" required errorClass="!text-customYellow-100"
                placeholder="Enter Password" customClass="!text-[16px] mobile:!py-[9px] mobile:!pl-[9px] largeDesktop:!py-[11px] largeDesktop:!pl-[11px] !rounded-[5px] mobile:!pr-[30px] largeDesktop:!pr-[35px]" />
            </div>
          </div>
        </div>
        <div
          class="grid mobile:gap-3 tablet:gap-4 largeDesktop:gap-8 mobile:my-5 largeDesktop:my-[40px] mobile:pb-5 largeDesktop:pb-[40px] border-b border-customYellow-100 w-full tablet:max-w-[400px]">
          <button
            class="CustomYellowBtn px-[40px] largeDesktop:px-[70px] py-[8px] largeDesktop:py-2.5 rounded-full uppercase font-roboto font-bold text-base tablet:text-lg w-max m-auto border-customYellow-100 border-solid border-[1px] disabled:hover:bg-none disabled:bg-transparent disabled:shadow-none disabled:border-[#ffffff7a] disabled:!text-[#ffffff7a] disabled:cursor-not-allowed focus:outline-none "
            type="submit" :disabled="issubmitDisabled()" @click="loginClicked()">
            Login
          </button>
          <a @click="forgetPassword" class="mx-auto no-underline w-max text-base tablet:text-lg font-normal cursor-pointer text-customYellow-100">Forgot
            password?</a>
        </div> 
        <button @click="creatAccountClicked"
          class="CustomYellowBtn px-4 largeDesktop:px-5 py-1.5 largeDesktop:py-2 font-normal text-base tablet:text-lg rounded-md focus:outline-none ">
          Create new account
        </button>
      </div>
    </div>
  </main>
</template>

<script>
import {
  mapActions,
  mapGetters
} from "vuex";
import inputComponent from '../../components/partialComponent/inputComponent.vue';
import {
  getBrowserFingerprint
} from '@/helpers/fingerprint';
export default {
  components: {
    inputComponent
  },
  data() {
    return {
      email: '',
      password: '',
      passwordVisible: false,
      showPasswordIcon: require("../../assets/images/show-password-icon.png"),
      hidePasswordIcon: require("../../assets/images/hide-password-icon.png"),
      fingerprint: '',
    };
  },

  watch: {
    userObject: function () {
      if (this.userObject != 'undefined') {
        if (this.userObject.user.email_verification == '0') {
          localStorage.setItem('registerFormData', JSON.stringify({
            email: this.email.trim()
          }));
          this.$router.push({
            name: 'verification'
          })
        } else {
          localStorage.removeItem('registerFormData')
          localStorage.setItem('user', JSON.stringify(this.userObject))
          localStorage.setItem('isSilentLogin', false)
          this.$router.push({
            path: '/dashboard'
          })
        }
      }

    },
  },

  computed: {
    ...mapGetters(["userObject"]),
    passwordFieldType() {
      return this.passwordVisible ? "text" : "password";
    },
  },

  async created() {
    this.fingerprint = await getBrowserFingerprint();
  },

  mounted() {
  },

  methods: {
    ...mapActions(["proLogin"]),

    issubmitDisabled() {

      if (this.email.length <= 0 || this.password.length <= 0) {
        return true
      }
      else if (!this.validateEmail()) {
        return true
      } else {
        return false
      }
    },

    validateEmail() {
      const emailPattern = this.$constants.EMAIL_REGEX;
      if (!emailPattern.test(this.email.trim())) {
        return false
      } else {
        return true
      }
    },

    onProLogin() {
      this.proLogin({
        email: this.email.trim(),
        password: this.password,
        device_type: 'web',
        device_id: this.fingerprint,
        user_type: 'affiliate'

      });
    },
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;
    },

    loginClicked() {
      this.onProLogin()
    },

    creatAccountClicked() {
      localStorage.removeItem('registerFormData');
      this.$router.push({
        name: 'register'
      })
    },

    forgetPassword() {
      this.$router.push({
        name: 'forgetPassword'
      })
    }
  },

};
</script>